<template>
    <span :class="classes">
        <slot />
    </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { WordsProps } from './types'

const props = defineProps<WordsProps>()

const classes = computed(() => {
    const out = []

    if (props.headline) out.push('text-headline')
    else if (props.text) out.push('text-text')
    else if (props.title) out.push('text-title')
    else if (props.titleLarge) out.push('text-title-large')
    else if (props.subtitle) out.push('text-subtitle')
    else if (props.paragraph) out.push('text-paragraph')
    else if (props.contract) out.push('text-contract')

    if (props.center) out.push('text-center')
    if (props.italic) out.push('text-italic')
    if (props.dense) out.push('text-dense')

    if (props.oneline) {
        out.push('text-one-line')
    } else if (props.twoline) {
        out.push('text-two-line')
    } else if (props.pre) {
        out.push('text-pre')
    } else {
        out.push('text-break')
    }

    return out
})
</script>

<style lang="sass" scoped>
@import './Words.sass'
</style>
